import React from "react";
import Typography from "../../Typography";
import Artists from "../../variables/Artists";

export default function MemberCardT2() {
  const artistCount = Artists.length;

  const getWidth = (index) => {
    if (artistCount === 2) return "w-[50%] max-sm:w-[100%]";
    if (artistCount === 3)
      return index < 2
        ? "w-[33.33%] max-md:w-[50%] max-sm:w-[100%]"
        : "w-[33.33%] max-md:w-[100%] max-sm:w-[100%]";
    if (artistCount === 4) return "w-[50%] max-md:w-[50%] max-sm:w-[100%]";
    if (artistCount === 5)
      return index === 4
        ? "w-[33.33%] max-md:w-[100%] max-sm:w-[100%]"
        : index < 2
        ? "w-[50%] max-md:w-[50%] max-sm:w-[100%]"
        : "w-[33.33%] max-md:w-[50%] max-sm:w-[100%]";
    if (artistCount === 7)
      return index === 0
        ? "w-[50%] max-md:w-[100%] max-sm:w-[100%]"
        : index < 2 || index >= 5
        ? "w-[50%] max-md:w-[50%] max-sm:w-[100%]"
        : "w-[33.33%] max-md:w-[50%] max-sm:w-[100%]";
    if (artistCount === 8)
      return index < 2
        ? "w-[50%] max-md:w-[50%] max-sm:w-[100%]"
        : "w-[33.33%] max-md:w-[50%] max-sm:w-[100%]";
    if (artistCount === 10)
      return index < 2 || index >= 8
        ? "w-[50%] max-md:w-[50%] max-sm:w-[100%]"
        : "w-[33.33%] max-md:w-[50%] max-sm:w-[100%]";
    return "w-[33.33%] max-md:w-[50%] max-sm:w-[100%]"; // Default case for 1, 6+ artists
  };

  return (
    <div className="flex flex-wrap justify-between items-center">
      {Artists.map((artist, index) => (
        <div
          key={index}
          className={`max-lg:h-[60vh] max-md:h-[50vw] max-sm:h-[70vw] max-xsm:h-[80vw] h-[35vw] ${getWidth(
            index
          )} Typography.Smp group relative`}
        >
          <div className="overflow-hidden z-[9] ease-in-out duration-500 absolute bottom-0 m-auto w-[100%] h-[100%] left-0 top-0 right-0 opacity-0 group-hover:opacity-100">
            <div className="max-md:h-[100px] hidden group-hover:flex overflow-hidden absolute left-[0] right-[0] h-[150px] bottom-[10px]">
              <div className="flex gap-[8px] animate-scroll whitespace-nowrap">
                {artist.portfolioLinks.slice(0, 5).map((project, i) => (
                  <img
                    key={i}
                    src={project.url}
                    className="max-md:h-[100px] max-md:min-w-[100px] h-[150px] min-w-[150px] object-cover"
                    alt={project.title}
                  />
                ))}
                {artist.portfolioLinks.slice(0, 5).map((project, i) => (
                  <img
                    key={i + 5} // Ensure unique keys
                    src={project.url}
                    className="h-[150px] min-w-[150px] object-cover"
                    alt={project.title}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="z-[7] overflow-hidden relative flex w-[100%] h-[100%]">
            <img
              className="h-[100%] w-[100%] absolute left-0 right-0 top-0 bottom-0 scale-100 group-hover:scale-110 duration-500 object-cover object-top grayscale"
              src={artist.profileimg}
              alt={artist.name}
            />
            <div className="bg-black opacity-50 group-hover:opacity-60 duration-500 absolute left-0 top-0 right-0 bottom-0"></div>
            <div className="absolute top-0 bottom-0 flex flex-col justify-center items-center w-full">
              <div>
                <Typography.P className="text-[#fff] ease-in-out duration-300 tracking-[1px]">
                  {artist.name}
                </Typography.P>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
